import { useState, useEffect } from "react"
import { useAuth } from "../../contexts/AuthContext"
import { useLanguage } from "../../contexts/LanguageContext"
import { useTheme } from "../../contexts/ThemeContext"
import { useNavigate, useLocation } from "react-router-dom"
import { HomeIcon, ServicesIcon, BookingsIcon, PaymentsIcon, ProfileIcon, MarketplaceIcon, ChatIcon, NotificationsIcon, GOServiceIcon, SearchIcon, SettingsIcon, WalletIcon, LocationIcon, StarIcon, VehicleIcon, ShieldIcon, DriversIcon, OrdersIcon, AnalyticsIcon, FilterIcon, LogoutIcon, HelpIcon, MechanicIcon, PartsIcon, ReportsIcon, SecurityIcon, TripReportIcon, LoyaltyIcon, FavoritesIcon, ReferEarnIcon, VehicleReportIcon, ServiceGuaranteeIcon, MyListingsIcon, MyTransactionsIcon, TruckDriverIcon, DiscoverIcon, MenuIcon, NoteIcon, ClockIcon, QRCodeIcon, TeamIcon, MovingCarIcon, CloseIcon, WarningIcon, PayoutIcon, TicketIcon, VideoIcon, BadgeIcon, DeleteIcon } from "../../lib/cccIcons"
import ThemeSwitcher from "./ThemeSwitcher"
import { supabase } from "../../lib/supabase"
import AIAssistant from "./AIAssistant"
import EmergencySOS from "./EmergencySOS"

const NAV = {
  customer: [
    { path:"/dashboard", key:"overview", icon:"overview" },
    { path:"/dashboard/bookings", key:"bookings", icon:"bookings" },
    { path:"/dashboard/services", key:"findServices", icon:"🔍" },
    { path:"/dashboard/vehicles", key:"myVehicles", icon:"🚗" },
    { path:"/dashboard/discover", key:"discover", icon:"🌍" },
    { path:"/dashboard/my-car-listings", label:"My Car Listings", icon:"🚗" },
    { path:"/dashboard/tracking", key:"trackDriver", icon:"📍" },
    { path:"/dashboard/trip-reports", label:"Trip Reports", icon:"🗺️" },
    { path:"/dashboard/loyalty", key:"loyalty", icon:"⭐" },
    { path:"/dashboard/payments", key:"payments", icon:"💳" },
    { path:"/dashboard/reviews", key:"reviews", icon:"reviews" },
    { path:"/dashboard/favorites", key:"favorites", icon:"❤️" },
    { path:"/dashboard/referral", key:"referEarn", icon:"🎁" },
    { path:"/dashboard/support", label:"Support", icon:"helpTicket" },
    { path:"/dashboard/emergency", label:"GO Service 🚨", icon:"🚨" },
    { path:"/dashboard/vehicle-reports", label:"Vehicle Reports", icon:"📋" },
    { path:"/dashboard/claims", label:"Service Guarantee", icon:"🛡️" },
    { path:"/dashboard/marketplace", label:"Marketplace", icon:"🛒" },

    { path:"/dashboard/marketplace/my-listings", label:"My Listings", icon:"📦" },
    { path:"/dashboard/marketplace/my-offers", label:"My Offers", icon:"💰" },
    { path:"/dashboard/marketplace/transactions", label:"My Transactions", icon:"💳" },
    { path:"/dashboard/chat", key:"messages", icon:"messages" },
    { path:"/dashboard/notifications", key:"notifications", icon:"notifications" },
    { path:"/dashboard/profile", key:"profile", icon:"profile" },
  ],
  provider: [], // built dynamically below

  driver: [
    { path:"/dashboard", key:"overview", icon:"overview" },
    { path:"/dashboard/jobs", key:"availableJobs", icon:"📦" },
    { path:"/dashboard/active", key:"activeDelivery", icon:"🚗" },
    { path:"/dashboard/deliveries", label:"Order Deliveries", icon:"📦" },
    { path:"/dashboard/earnings", key:"earnings", icon:"wallet" },
    { path:"/dashboard/reviews", key:"myRatings", icon:"⭐" },
    { path:"/dashboard/payouts", key:"payouts", icon:"payout" },
    { path:"/dashboard/claims", label:"My Claims", icon:"🛡️" },
    { path:"/dashboard/application", label:"My Application", icon:"📋" },
    { path:"/dashboard/vehicle", label:"My Vehicle", icon:"🚗" },
    { path:"/dashboard/performance", label:"Performance", icon:"📊" },





    { path:"/dashboard/notifications", key:"notifications", icon:"notifications" },
    { path:"/dashboard/chat", key:"messages", icon:"messages" },
    { path:"/dashboard/profile", key:"profile", icon:"profile" },
  ],
  admin: [
    { path:"/admin-dashboard", key:"overview", icon:"overview" },
    { path:"/admin-dashboard/users", label:"Users", icon:"users" },
    { path:"/admin-dashboard/providers", label:"Providers", icon:"services" },
    { path:"/admin-dashboard/drivers", label:"Drivers", icon:"vehicle" },
    { path:"/admin-dashboard/live-map", label:"Live Map", icon:"map" },
    { path:"/admin-dashboard/trip-reports", label:"Trip Reports", icon:"tripReport" },
    { path:"/admin-dashboard/mechanics", label:"Mechanics & Services", icon:"mechanic" },
    { path:"/admin-dashboard/penalties", label:"Penalties", icon:"block" },
    { path:"/admin-dashboard/disputes", label:"Disputes & Reports", icon:"warning" },
    { path:"/admin-dashboard/claims", label:"Service Claims", icon:"shield" },
    { path:"/admin-dashboard/bookings", key:"bookings", icon:"bookings" },
    { path:"/admin-dashboard/services", label:"Services", icon:"settings" },
    { path:"/admin-dashboard/revenue", label:"Revenue", icon:"wallet" },
    { path:"/admin-dashboard/payouts", label:"Payouts", icon:"payout" },
    { path:"/admin-dashboard/promos", label:"Promo Codes", icon:"ticket" },
    { path:"/admin-dashboard/reviews", key:"reviews", icon:"⭐" },
    { path:"/admin-dashboard/loyalty", key:"loyalty", icon:"🏠" },
    { path:"/admin-dashboard/categories", label:"Categories", icon:"orders" },
    { path:"/admin-dashboard/security", label:"2FA Security", icon:"security" },
    { path:"/admin-dashboard/support", label:"Support Tickets", icon:"helpTicket" },
    { path:"/admin-dashboard/notifications", label:"Notifications", icon:"notifications" },
    { path:"/admin-dashboard/health", label:"System Health", icon:"health" },
    { path:"/admin-dashboard/diagnostics", label:"Diagnostics", icon:"analytics" },
    { path:"/admin-dashboard/commissions", label:"Commissions", icon:"commissions" },
    { path:"/admin-dashboard/settings", label:"Settings", icon:"adminSettings" },
    { path:"/admin-dashboard/qrcode", label:"QR Code", icon:"qr" },
    { path:"/admin-dashboard/content-hub", label:"Content Hub", icon:"video" },
    { path:"/admin-dashboard/new-cars", label:"New Cars", icon:"newCar" },
    { path:"/admin-dashboard/driver-vetting", label:"Driver Vetting", icon:"badge" },
    { path:"/admin-dashboard/marketplace", label:"Marketplace", icon:"marketplace" },
    { path:"/admin-dashboard/employees", label:"Employees", icon:"team" },
    { path:"/admin-dashboard/orders", label:"Orders", icon:"adminOrders" },
    { path:"/admin-dashboard/inventory", label:"Inventory", icon:"parts" },
    { path:"/admin-dashboard/payment-tracking", label:"Payment Tracking", icon:"payments" },
    { path:"/admin-dashboard/failed-jobs", label:"Failed Jobs", icon:"failedJobs" },
    { path:"/admin-dashboard/deletion-requests", label:"Deletion Requests", icon:"delete" },

  ],
}
const BOTTOM_NAV = {
  customer: [
    { path:"/dashboard", key:"overview", icon:"overview" },
    { path:"/dashboard/bookings", key:"bookings", icon:"📅" },
    { path:"/dashboard/services", key:"findServices", icon:"🔍" },
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"more", label:"Menu", icon:"☰" },
  ],
  provider: [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/bookings", key:"bookings", icon:"📅" },
    { path:"/dashboard/services", key:"myServices", icon:"services" },
    { path:"/dashboard/mechanics", label:"Mechanics", icon:"👨‍🔧" },
    { path:"more", label:"Menu", icon:"☰" },
  ],
  driver: [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/jobs", key:"availableJobs", icon:"📦" },
    { path:"/dashboard/active", key:"activeDelivery", icon:"🚗" },
    { path:"/dashboard/earnings", key:"earnings", icon:"wallet" },
    { path:"more", label:"Menu", icon:"☰" },

  ],
  admin: [
    { path:"/admin-dashboard", key:"overview", icon:"overview" },
    { path:"/admin-dashboard/users", label:"Users", icon:"users" },
    { path:"/admin-dashboard/bookings", key:"bookings", icon:"📅" },
    { path:"/admin-dashboard/revenue", label:"Revenue", icon:"wallet" },
    { path:"more", label:"Menu", icon:"☰" },
  ],
}
export default function Layout({ children }) {
  const { profile, signOut } = useAuth()
  const { t, language, toggleLanguage } = useLanguage()
  const { theme } = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const [collapsed, setCollapsed] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [showThemeBanner, setShowThemeBanner] = useState(!localStorage.getItem("ccc_theme_banner_seen"))
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [unreadCount, setUnreadCount] = useState(0)
  const [unreadChat, setUnreadChat] = useState(0)
  const { user } = useAuth()

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
  }, [])

  const role = profile?.role || "customer"
  // Block suspended/banned users from all dashboard features (providers, customers, drivers)
  if(profile?.is_banned) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem", textAlign:"center" }}>
      <div><div style={{ fontSize:48, marginBottom:16 }}>🚫</div>
      <div style={{ fontFamily:"Syne", fontSize:20, fontWeight:800, color:"#e24b4a", marginBottom:8 }}>Account Permanently Banned</div>
      <div style={{ fontSize:13, color:"#666", maxWidth:320 }}>Your account has been permanently banned due to repeated service violations. Contact support if you believe this is an error.</div>
      <div style={{ marginTop:16, fontSize:12, color:"#888" }}>support: carcareconnect254@gmail.com</div></div>
    </div>
  )
  if(profile?.is_suspended) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem", textAlign:"center" }}>
      <div><div style={{ fontSize:48, marginBottom:16 }}>⏸️</div>
      <div style={{ fontFamily:"Syne", fontSize:20, fontWeight:800, color:"#e6821e", marginBottom:8 }}>Account Suspended</div>
      <div style={{ fontSize:13, color:"#666", maxWidth:320 }}>Your account has been temporarily suspended due to a service claim violation.</div>
      {profile?.suspension_expires_at&&<div style={{ fontSize:12, color:"#e6821e", marginTop:8 }}>Suspension lifts: {new Date(profile.suspension_expires_at).toLocaleString("en-KE")}</div>}
      <div style={{ marginTop:16, fontSize:12, color:"#888" }}>Contact: carcareconnect254@gmail.com</div></div>
    </div>
  )

  useEffect(() => {
    if (!user) return
    supabase.from("notifications").select("id",{count:"exact"}).eq("user_id",user.id).eq("is_read",false).then(({count})=>setUnreadCount(count||0))
    supabase.from("chat_messages").select("id",{count:"exact"}).eq("receiver_id",user.id).eq("is_read",false).then(({count})=>setUnreadChat(count||0))
    const sub = supabase.channel(`layout-notifs-${user.id}`)
      .on("postgres_changes",{event:"INSERT",schema:"public",table:"notifications",filter:`user_id=eq.${user.id}`},()=>setUnreadCount(c=>c+1))
      .on("postgres_changes",{event:"INSERT",schema:"public",table:"chat_messages",filter:`receiver_id=eq.${user.id}`},()=>setUnreadChat(c=>c+1))
      .on("postgres_changes",{event:"UPDATE",schema:"public",table:"notifications",filter:`user_id=eq.${user.id}`},()=>{
        supabase.from("notifications").select("id",{count:"exact"}).eq("user_id",user.id).eq("is_read",false).then(({count})=>setUnreadCount(count||0))
    supabase.from("chat_messages").select("id",{count:"exact"}).eq("receiver_id",user.id).eq("is_read",false).then(({count})=>setUnreadChat(count||0))
      })
      .subscribe()
    return () => supabase.removeChannel(sub)
  }, [user?.id])
  const providerType = profile?.provider_type || "garage"
  const isInventoryProvider = ["parts_dealer","accessories_shop","tyre_shop"].includes(providerType)
  const isPureInventoryProvider = ["parts_dealer","accessories_shop"].includes(providerType)
  const hasInventory = ["parts_dealer","accessories_shop","tyre_shop","auto_glass"].includes(providerType)
  const isServiceProvider = ["garage","garage_premium","auto_electrician","car_wash","panel_beater","auto_glass"].includes(providerType)
  const isTyreShop = providerType === "tyre_shop"
  const driverCategory = profile?.driver_category || "marketplace"
  const isConciergeDriver = driverCategory === "concierge"
  const vehicleLabel = profile?.driver_vehicle_type === "motorcycle" ? "My Bodaboda" 
    : profile?.driver_vehicle_type === "tuktuk" ? "My Tuktuk"
    : profile?.driver_vehicle_type === "van" ? "My Van/Pickup"
    : "My Car"
  const vehicleIcon = profile?.driver_vehicle_type === "motorcycle" ? "🏍️"
    : profile?.driver_vehicle_type === "tuktuk" ? "🛺"
    : profile?.driver_vehicle_type === "van" ? "🚐"
    : "🚗"


























  const providerNav = [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    ...(!isPureInventoryProvider ? [{ path:"/dashboard/bookings", key:"bookings", icon:"bookings" }] : []),
    ...(!isPureInventoryProvider ? [{ path:"/dashboard/services", key:"myServices", icon:"services" }] : []),
    ...( ["garage","garage_premium","panel_beater","auto_electrician","mobile_mechanic"].includes(providerType) ? [
      { path:"/dashboard/bundles", label:"Service Bundles", icon:"services" },
    ] : []),
    ...( hasInventory ? [
      { path:"/dashboard/inventory", label:"Inventory", icon:"parts" },
      { path:"/dashboard/orders", label:"Orders", icon:"orders" },
    ] : []),
    { path:"/dashboard/earnings", key:"earnings", icon:"wallet" },
    { path:"/dashboard/analytics", key:"analytics", icon:"analytics" },
    { path:"/dashboard/qrcode", label:"My QR Code", icon:"qr" },
    { path:"/dashboard/reviews", key:"reviews", icon:"reviews" },
    { path:"/dashboard/customer-reviews", label:"Rate Customers", icon:"profile" },
    { path:"/dashboard/business-hours", label:"Business Hours", icon:"clock" },
    { path:"/dashboard/availability", key:"availability", icon:"bookings" },
    { path:"/dashboard/payouts", key:"payouts", icon:"payout" },
    ...( ["garage","garage_premium","auto_electrician"].includes(providerType) ? [
      { path:"/dashboard/mechanics", label:"My Mechanics", icon:"mechanic" },
    ] : []),
    ...( ["garage","garage_premium","auto_electrician"].includes(providerType) ? [
      { path:"/dashboard/go-requests", label:"GO Requests", icon:"emergency" },
    ] : []),
    { path:"/dashboard/claims", label:"Service Claims", icon:"shield" },
    { path:"/dashboard/support", label:"Support", icon:"helpTicket" },
    ...( ["car_wash"].includes(providerType) ? [
      { path:"/dashboard/wash-queue", label:"Wash Queue", icon:"discover" },
      { path:"/dashboard/staff", label:"Staff Management", icon:"team" },
    ] : []),
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"/dashboard/notifications", key:"notifications", icon:"notifications" },
    { path:"/dashboard/profile", key:"profile", icon:"⚙️" },
  ]

  const driverNav = isConciergeDriver ? [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/jobs", key:"availableJobs", icon:"📦" },
    { path:"/dashboard/active", key:"activeDelivery", icon:"🚗" },
    { path:"/dashboard/earnings", key:"earnings", icon:"💰" },
    { path:"/dashboard/reviews", key:"myRatings", icon:"⭐" },
    { path:"/dashboard/payouts", key:"payouts", icon:"🏦" },
    { path:"/dashboard/claims", label:"My Claims", icon:"🛡️" },
    { path:"/dashboard/application", label:"My Application", icon:"📋" },
    { path:"/dashboard/performance", label:"Performance", icon:"📊" },
    { path:"/dashboard/notifications", key:"notifications", icon:"🔔" },
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"/dashboard/support", label:"Support", icon:"🎫" },
    { path:"/dashboard/profile", key:"profile", icon:"⚙️" },
  ] : [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/deliveries", label:"Order Deliveries", icon:"📦" },
    { path:"/dashboard/earnings", key:"earnings", icon:"💰" },
    { path:"/dashboard/reviews", key:"myRatings", icon:"⭐" },
    { path:"/dashboard/payouts", key:"payouts", icon:"🏦" },
    { path:"/dashboard/claims", label:"My Claims", icon:"🛡️" },
    { path:"/dashboard/vehicle", label:vehicleLabel, icon:vehicleIcon },
    { path:"/dashboard/notifications", key:"notifications", icon:"🔔" },
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"/dashboard/profile", key:"profile", icon:"⚙️" },
  ]
  const nav = role === "provider" ? providerNav : role === "driver" ? driverNav : (NAV[role] || [])
  const isDeliveryDriver = ["motorcycle","tuktuk","van"].includes(profile?.driver_vehicle_type||"car")
  const providerBottomNav = isPureInventoryProvider ? [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/inventory", label:"Inventory", icon:"📦" },
    { path:"/dashboard/orders", label:"Orders", icon:"🛒" },
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"more", label:"Menu", icon:"☰" },
  ] : hasInventory ? [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/bookings", key:"bookings", icon:"📅" },
    { path:"/dashboard/inventory", label:"Inventory", icon:"📦" },
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"more", label:"Menu", icon:"☰" },
  ] : [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/bookings", key:"bookings", icon:"📅" },
    { path:"/dashboard/services", key:"myServices", icon:"🔧" },
    { path:"/dashboard/chat", key:"messages", icon:"✉️" },
    { path:"more", label:"Menu", icon:"☰" },
  ]
  const driverBottomNav = isConciergeDriver ? [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/jobs", key:"availableJobs", icon:"📦" },
    { path:"/dashboard/active", key:"activeDelivery", icon:"🚗" },
    { path:"/dashboard/earnings", key:"earnings", icon:"💰" },
    { path:"more", label:"Menu", icon:"☰" },
  ] : [
    { path:"/dashboard", key:"overview", icon:"🏠" },
    { path:"/dashboard/deliveries", label:"Deliveries", icon:"📦" },
    { path:"/dashboard/earnings", key:"earnings", icon:"💰" },
    { path:"more", label:"Menu", icon:"☰" },
  ]
  const initials = `${profile?.first_name?.[0]||""}${profile?.last_name?.[0]||""}`.toUpperCase()
  const bottomNav = role==="provider" ? providerBottomNav : role==="driver" ? driverBottomNav : (BOTTOM_NAV[role] || [])

  const roleColors = {
    customer: { active:"#e6821e", activeBg:"#fff8f0" },
    provider: { active:"#378add", activeBg:"#eff6ff" },
    driver:   { active:"#1d9e75", activeBg:"#f0fdf4" },
    admin:    { active:"#8b5cf6", activeBg:"#f5f3ff" },
  }
  const activeColor = roleColors[role]?.active || theme.primary
  const activeBg = roleColors[role]?.activeBg || theme.primaryBg

  function getLabel(item) {
    if (item.key) return t(item.key)
    return item.label || ""
  }

  function isActive(item) {
    if (item.path === "/dashboard" || item.path === "/admin-dashboard") {
      return location.pathname === item.path
    }
    return location.pathname === item.path || location.pathname.startsWith(item.path + "/")
  }

  if (isMobile) return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", background:theme.bg||"#ffffff", fontFamily:"DM Sans,sans-serif", color:theme.text||"#000000" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');
      ::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-track{background:transparent;}::-webkit-scrollbar-thumb{background:${theme.border};border-radius:2px;}
      ::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-track{background:transparent;}::-webkit-scrollbar-thumb{background:${theme.border};border-radius:2px;}
      @keyframes notif-glow{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.3);opacity:0.7}}
      @keyframes chat-glow{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.3);opacity:0.7}}
      .notif-badge{animation:notif-glow 1s ease-in-out infinite}
      .chat-badge{animation:chat-glow 1s ease-in-out infinite}
      @keyframes chat-glow{0%,100%{filter:drop-shadow(0 0 2px #378add)}50%{filter:drop-shadow(0 0 5px #378add)}}`}</style>

      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0.75rem 1rem", borderBottom:`1px solid ${theme.border}`, background:theme.bgSecondary, position:"sticky", top:0, zIndex:50 }}>
        <div style={{ fontFamily:"Syne", fontSize:15, fontWeight:800, color:theme.text }}>
          {{"garage":"🔧","garage_premium":"🚗","parts_dealer":"⚙️","accessories_shop":"✨","tyre_shop":"🛞","auto_electrician":"⚡","car_wash":"🚿","panel_beater":"🔨","auto_glass":"🪟"}[providerType]||"🚗"} Car<span style={{ color:activeColor }}>Care</span>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{ fontFamily:"Syne", fontSize:13, fontWeight:700, color:theme.textMuted }}>
            {getLabel(nav.find(n=>isActive(n))||{}) || "Dashboard"}
          </div>
          <button onClick={()=>setMobileMenuOpen(o=>!o)}
            style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:8, color:theme.text, cursor:"pointer", fontSize:18, padding:"4px 10px" }}>
            {mobileMenuOpen?"✕":"☰"}
          </button>
        </div>
      </div>

      {mobileMenuOpen&&(
        <div style={{ position:"fixed", inset:0, zIndex:100, display:"flex" }}>
          <div style={{ flex:1, background:"rgba(0,0,0,0.6)" }} onClick={()=>setMobileMenuOpen(false)}/>
          <div style={{ width:260, background:theme.bgSecondary, borderLeft:`1px solid ${theme.border}`, display:"flex", flexDirection:"column", overflowY:"auto" }}>
            <div style={{ padding:"1rem", borderBottom:`1px solid ${theme.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ fontFamily:"Syne", fontSize:15, fontWeight:800, color:theme.text }}>Menu</div>
              <button onClick={()=>setMobileMenuOpen(false)} style={{ background:"none", border:"none", color:theme.textFaint, cursor:"pointer", fontSize:20 }}>✕</button>
            </div>
            <div style={{ padding:"0.5rem", flex:1 }}>
              {nav.map(item=>(
                <button key={item.path}
                  onClick={()=>{ navigate(item.path); setMobileMenuOpen(false) }}
                  style={{ display:"flex", alignItems:"center", gap:10, width:"100%", padding:"10px 12px", background:isActive(item)?activeBg:"transparent", border:`1px solid ${isActive(item)?activeColor:"transparent"}`, borderRadius:9, color:isActive(item)?activeColor:theme.textMuted, fontSize:13, cursor:"pointer", marginBottom:4, fontFamily:"'DM Sans',sans-serif", textAlign:"left", fontWeight:isActive(item)?600:400 }}>
                  <span style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
              {item.key==="overview" ? <HomeIcon size={20} active={isActive(item)} /> :
               item.key==="bookings" ? <BookingsIcon size={20} active={isActive(item)} /> :
               item.key==="findServices"||item.key==="myServices" ? <ServicesIcon size={20} active={isActive(item)} /> :
               item.key==="messages" ? <ChatIcon size={20} active={isActive(item)} /> :
               item.key==="notifications" ? <NotificationsIcon size={20} active={isActive(item)} /> :
               item.key==="payments" ? <PaymentsIcon size={20} active={isActive(item)} /> :
               item.label==="Marketplace" ? <MarketplaceIcon size={20} active={isActive(item)} /> :
               item.key==="reviews"||item.key==="myRatings" ? <StarIcon size={20} active={isActive(item)} /> :
               item.key==="analytics" ? <AnalyticsIcon size={20} active={isActive(item)} /> :
               item.key==="earnings"||item.key==="payouts" ? <WalletIcon size={20} active={isActive(item)} /> :
               item.key==="loyalty" ? <LoyaltyIcon size={20} active={isActive(item)} /> :
               item.key==="favorites" ? <FavoritesIcon size={20} active={isActive(item)} /> :
               item.key==="referEarn" ? <ReferEarnIcon size={20} active={isActive(item)} /> :
               item.key==="discover" ? <DiscoverIcon size={20} active={isActive(item)} /> :
               item.key==="myVehicles" ? <VehicleIcon size={20} active={isActive(item)} /> :
               item.key==="trackDriver" ? <LocationIcon size={20} active={isActive(item)} /> :
               item.key==="availableJobs" ? <OrdersIcon size={20} active={isActive(item)} /> :
               item.key==="activeDelivery" ? <MovingCarIcon size={20} active={isActive(item)} /> :
               item.key==="profile" ? <ProfileIcon size={20} active={isActive(item)} /> :
               item.label==="GO Service 🚨"||item.label==="GO Service" ? <GOServiceIcon size={20} color="#e24b4a" /> :
               item.label==="My Vehicles" ? <VehicleIcon size={20} active={isActive(item)} /> :
               item.label==="Discover" ? <DiscoverIcon size={20} active={isActive(item)} /> :
               item.label==="My Car Listings" ? <MyListingsIcon size={20} active={isActive(item)} /> :
               item.label==="Track Driver" ? <LocationIcon size={20} active={isActive(item)} /> :
               item.label==="Trip Reports" ? <TripReportIcon size={20} active={isActive(item)} /> :
               item.label==="Loyalty" ? <LoyaltyIcon size={20} active={isActive(item)} /> :
               item.label==="Reviews" ? <StarIcon size={20} active={isActive(item)} /> :
               item.label==="Favorites" ? <FavoritesIcon size={20} active={isActive(item)} /> :
               item.label==="Refer & Earn" ? <ReferEarnIcon size={20} active={isActive(item)} /> :
               item.label==="Support" ? <HelpIcon size={20} active={isActive(item)} /> :
               item.label==="Vehicle Reports" ? <VehicleReportIcon size={20} active={isActive(item)} /> :
               item.label==="Service Guarantee" ? <ServiceGuaranteeIcon size={20} active={isActive(item)} /> :
               item.label==="My Listings" ? <MyListingsIcon size={20} active={isActive(item)} /> :
               item.label==="My Offers" ? <MarketplaceIcon size={20} active={isActive(item)} /> :
               item.label==="My Transactions" ? <MyTransactionsIcon size={20} active={isActive(item)} /> :
               item.label==="Settings" ? <SettingsIcon size={20} active={isActive(item)} /> :
               item.label==="Drivers" ? <DriversIcon size={20} active={isActive(item)} /> :
               item.label==="Mechanics"||item.label==="My Mechanics" ? <MechanicIcon size={20} active={isActive(item)} /> :
               item.label==="Spare Parts"||item.label==="Inventory" ? <PartsIcon size={20} active={isActive(item)} /> :
               item.label==="Orders" ? <OrdersIcon size={20} active={isActive(item)} /> :
               item.label==="Earnings" ? <WalletIcon size={20} active={isActive(item)} /> :
               item.label==="Service Claims"||item.label==="My Claims" ? <ServiceGuaranteeIcon size={20} active={isActive(item)} /> :
               item.label==="Order Deliveries"||item.label==="Deliveries" ? <TruckDriverIcon size={20} active={isActive(item)} /> :
               item.label==="My Vehicle" ? <VehicleIcon size={20} active={isActive(item)} /> :
               item.label==="Performance" ? <AnalyticsIcon size={20} active={isActive(item)} /> :
               item.label==="My Application" ? <NoteIcon size={20} active={isActive(item)} /> :
               item.label==="Business Hours" ? <ClockIcon size={20} active={isActive(item)} /> :
               item.label==="Availability" ? <BookingsIcon size={20} active={isActive(item)} /> :
               item.label==="My QR Code" ? <QRCodeIcon size={20} active={isActive(item)} /> :
               item.label==="GO Requests" ? <GOServiceIcon size={20} color="#e24b4a" /> :
               item.label==="Service Bundles" ? <ServicesIcon size={20} active={isActive(item)} /> :
               item.label==="Wash Queue"||item.label==="Wash Packages" ? <DiscoverIcon size={20} active={isActive(item)} /> :
               item.label==="Staff Management" ? <TeamIcon size={20} active={isActive(item)} /> :
               item.label==="Rate Customers" ? <StarIcon size={20} active={isActive(item)} /> :
               item.icon==="overview"?<HomeIcon size={20} active={isActive(item)}/>:
               item.icon==="users"?<ProfileIcon size={20} active={isActive(item)}/>:
               item.icon==="vehicle"?<VehicleIcon size={20} active={isActive(item)}/>:
               item.icon==="map"?<TripReportIcon size={20} active={isActive(item)}/>:
               item.icon==="tripReport"?<TripReportIcon size={20} active={isActive(item)}/>:
               item.icon==="mechanic"?<MechanicIcon size={20} active={isActive(item)}/>:
               item.icon==="block"?<CloseIcon size={20} active={isActive(item)}/>:
               item.icon==="warning"?<WarningIcon size={20} color={isActive(item)?"#e6821e":"#64748B"}/>:
               item.icon==="shield"?<ShieldIcon size={20} active={isActive(item)}/>:
               item.icon==="wallet"?<WalletIcon size={20} active={isActive(item)}/>:
               item.icon==="payout"?<PayoutIcon size={20} active={isActive(item)}/>:
               item.icon==="ticket"?<TicketIcon size={20} active={isActive(item)}/>:
               item.icon==="security"?<SecurityIcon size={20} active={isActive(item)}/>:
               item.icon==="helpTicket"?<HelpIcon size={20} active={isActive(item)}/>:
               item.icon==="health"?<HelpIcon size={20} active={isActive(item)}/>:
               item.icon==="analytics"?<AnalyticsIcon size={20} active={isActive(item)}/>:
               item.icon==="commissions"?<AnalyticsIcon size={20} active={isActive(item)}/>:
               item.icon==="adminSettings"?<SettingsIcon size={20} active={isActive(item)}/>:
               item.icon==="qr"?<QRCodeIcon size={20} active={isActive(item)}/>:
               item.icon==="video"?<VideoIcon size={20} active={isActive(item)}/>:
               item.icon==="newCar"?<VehicleIcon size={20} active={isActive(item)}/>:
               item.icon==="badge"?<BadgeIcon size={20} active={isActive(item)}/>:
               item.icon==="team"?<TeamIcon size={20} active={isActive(item)}/>:
               item.icon==="adminOrders"?<OrdersIcon size={20} active={isActive(item)}/>:
               item.icon==="payments"?<PaymentsIcon size={20} active={isActive(item)}/>:
               item.icon==="failedJobs"?<WarningIcon size={20} color="#e24b4a"/>:
               item.icon==="delete"?<DeleteIcon size={20} color="#e24b4a"/>:
               item.icon==="settings"?<SettingsIcon size={20} active={isActive(item)}/>:
               item.icon==="bookings"?<BookingsIcon size={18} active={isActive(item)}/>:
               item.icon==="wallet"?<WalletIcon size={18} active={isActive(item)}/>:
               item.icon==="star"?<StarIcon size={18} active={isActive(item)}/>:
               item.icon==="payout"?<PayoutIcon size={18} active={isActive(item)}/>:
               item.icon==="qr"?<QRCodeIcon size={18} active={isActive(item)}/>:
               item.icon==="notifications"?<NotificationsIcon size={18} active={isActive(item)}/>:
               item.icon==="messages"?<ChatIcon size={18} active={isActive(item)}/>:
               item.icon==="clock"?<ClockIcon size={18} active={isActive(item)}/>:
               item.icon==="overview"?<HomeIcon size={18} active={isActive(item)}/>:
               item.icon==="services"?<ServicesIcon size={18} active={isActive(item)}/>:
               item.icon==="orders"?<OrdersIcon size={18} active={isActive(item)}/>:
               item.icon==="emergency"?<GOServiceIcon size={18} color="#e24b4a"/>:
               item.icon==="helpTicket"?<HelpIcon size={18} active={isActive(item)}/>:
               item.icon==="profile"?<ProfileIcon size={18} active={isActive(item)}/>:
               item.icon==="mechanic"?<MechanicIcon size={18} active={isActive(item)}/>:
               item.icon==="shield"?<ShieldIcon size={18} active={isActive(item)}/>:
               item.icon==="parts"?<PartsIcon size={18} active={isActive(item)}/>:
               item.icon==="analytics"?<AnalyticsIcon size={18} active={isActive(item)}/>:
               item.icon==="vehicle"?<VehicleIcon size={18} active={isActive(item)}/>:
               item.icon==="discover"?<DiscoverIcon size={18} active={isActive(item)}/>:
               item.icon==="team"?<TeamIcon size={18} active={isActive(item)}/>:
               <span style={{fontSize:18}}>{item.icon}</span>}
            </span>
                  {getLabel(item)}
                </button>
              ))}
            </div>
            <div style={{ padding:"1rem", borderTop:`1px solid ${theme.border}` }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12, padding:"0.75rem", background:theme.bgCard, borderRadius:8 }}>
                <div style={{ width:32, height:32, borderRadius:"50%", background:activeBg, border:`1px solid ${activeColor}40`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:800, color:activeColor, flexShrink:0 }}>{initials}</div>
                <div style={{ minWidth:0, flex:1 }}>
                  <div style={{ fontSize:12, color:theme.text, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{profile?.first_name} {profile?.last_name}</div>
                  <div style={{ fontSize:10, color:theme.textFaint, textTransform:"capitalize" }}>
                {role==="provider"?providerType.replace(/_/g," "):role}
              </div>
                </div>
              </div>
              <ThemeSwitcher collapsed={false} />
              <button onClick={toggleLanguage}
                style={{ background:"none", border:`1px solid ${theme.border}`, borderRadius:6, color:theme.textFaint, cursor:"pointer", fontSize:11, width:"100%", textAlign:"center", fontFamily:"'DM Sans',sans-serif", padding:"7px 0", marginTop:6, marginBottom:6 }}>
                🌐 {language==="en"?"Kiswahili":"English"}
              </button>
              <button onClick={()=>{ signOut(); setMobileMenuOpen(false) }}
                style={{ background:"#fff5f5", border:"1px solid #e24b4a40", borderRadius:8, color:"#e24b4a", cursor:"pointer", fontSize:13, fontWeight:700, width:"100%", textAlign:"center", fontFamily:"'DM Sans',sans-serif", padding:"10px 0" }}>
                🚪 {t("signOut")}
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ flex:1, padding:"1rem", overflowY:"auto", paddingBottom:80, background: role==="admin" ? "#f5f5f5" : "transparent" }}>
        {children}
      </div>

      <AIAssistant />
      <EmergencySOS />
      {showMore&&(
        <>
          <div onClick={()=>setShowMore(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:98}}/>
          <div style={{position:"fixed",bottom:56,left:0,right:0,background:theme.bgCard,borderTop:"1px solid "+theme.border,borderTopLeftRadius:20,borderTopRightRadius:20,zIndex:99,maxHeight:"75vh",overflowY:"auto",padding:"1rem 1rem 2rem"}}>
            <div style={{width:40,height:4,background:theme.border,borderRadius:2,margin:"0 auto 1rem"}}/>
            <div style={{fontFamily:"Syne",fontSize:14,fontWeight:800,color:theme.text,marginBottom:"1rem"}}>All Features</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
              {NAV[role]?.map((item,idx)=>(
                <button key={item.path+idx} onClick={()=>{navigate(item.path);setShowMore(false)}}
                  style={{background:location.pathname===item.path?activeBg:"transparent",border:"1px solid "+(location.pathname===item.path?activeColor:theme.border),borderRadius:10,padding:"0.75rem 0.5rem",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                  <span style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                {item.key==="overview" ? <HomeIcon size={22} active={isActive(item)} /> :
                 item.key==="bookings" ? <BookingsIcon size={22} active={isActive(item)} /> :
                 item.key==="findServices"||item.key==="myServices" ? <ServicesIcon size={22} active={isActive(item)} /> :
                 item.key==="messages" ? <ChatIcon size={22} active={isActive(item)} /> :
                 item.key==="notifications" ? <NotificationsIcon size={22} active={isActive(item)} hasAlert={unreadCount>0} /> :
                 item.key==="payments" ? <PaymentsIcon size={22} active={isActive(item)} /> :
                 item.key==="reviews"||item.key==="myRatings" ? <StarIcon size={22} active={isActive(item)} /> :
                 item.key==="profile" ? <ProfileIcon size={22} active={isActive(item)} /> :
                 item.label==="Marketplace" ? <MarketplaceIcon size={22} active={isActive(item)} /> :
                 item.label==="Settings" ? <SettingsIcon size={22} active={isActive(item)} /> :
                 item.icon==="bookings"?<BookingsIcon size={20} active={isActive(item)}/>:
               item.icon==="wallet"?<WalletIcon size={20} active={isActive(item)}/>:
               item.icon==="star"?<StarIcon size={20} active={isActive(item)}/>:
               item.icon==="payout"?<PayoutIcon size={20} active={isActive(item)}/>:
               item.icon==="qr"?<QRCodeIcon size={20} active={isActive(item)}/>:
               item.icon==="notifications"?<NotificationsIcon size={20} active={isActive(item)}/>:
               item.icon==="messages"?<ChatIcon size={20} active={isActive(item)}/>:
               item.icon==="clock"?<ClockIcon size={20} active={isActive(item)}/>:
               item.icon==="overview"?<HomeIcon size={20} active={isActive(item)}/>:
               item.icon==="services"?<ServicesIcon size={20} active={isActive(item)}/>:
               item.icon==="orders"?<OrdersIcon size={20} active={isActive(item)}/>:
               item.icon==="emergency"?<GOServiceIcon size={20} color="#e24b4a"/>:
               item.icon==="helpTicket"?<HelpIcon size={20} active={isActive(item)}/>:
               item.icon==="profile"?<ProfileIcon size={20} active={isActive(item)}/>:
               item.icon==="mechanic"?<MechanicIcon size={20} active={isActive(item)}/>:
               item.icon==="shield"?<ShieldIcon size={20} active={isActive(item)}/>:
               item.icon==="parts"?<PartsIcon size={20} active={isActive(item)}/>:
               item.icon==="analytics"?<AnalyticsIcon size={20} active={isActive(item)}/>:
               item.icon==="vehicle"?<VehicleIcon size={20} active={isActive(item)}/>:
               item.icon==="discover"?<DiscoverIcon size={20} active={isActive(item)}/>:
               item.icon==="team"?<TeamIcon size={20} active={isActive(item)}/>:
               item.icon==="bookings"?<BookingsIcon size={20} active={isActive(item)}/>:
               item.icon==="wallet"?<WalletIcon size={20} active={isActive(item)}/>:
               item.icon==="star"?<StarIcon size={20} active={isActive(item)}/>:
               item.icon==="payout"?<PayoutIcon size={20} active={isActive(item)}/>:
               item.icon==="qr"?<QRCodeIcon size={20} active={isActive(item)}/>:
               item.icon==="notifications"?<NotificationsIcon size={20} active={isActive(item)}/>:
               item.icon==="messages"?<ChatIcon size={20} active={isActive(item)}/>:
               item.icon==="clock"?<ClockIcon size={20} active={isActive(item)}/>:
               item.icon==="overview"?<HomeIcon size={20} active={isActive(item)}/>:
               item.icon==="services"?<ServicesIcon size={20} active={isActive(item)}/>:
               item.icon==="orders"?<OrdersIcon size={20} active={isActive(item)}/>:
               item.icon==="emergency"?<GOServiceIcon size={20} color="#e24b4a"/>:
               item.icon==="helpTicket"?<HelpIcon size={20} active={isActive(item)}/>:
               item.icon==="profile"?<ProfileIcon size={20} active={isActive(item)}/>:
               item.icon==="mechanic"?<MechanicIcon size={20} active={isActive(item)}/>:
               item.icon==="shield"?<ShieldIcon size={20} active={isActive(item)}/>:
               item.icon==="parts"?<PartsIcon size={20} active={isActive(item)}/>:
               item.icon==="analytics"?<AnalyticsIcon size={20} active={isActive(item)}/>:
               item.icon==="vehicle"?<VehicleIcon size={20} active={isActive(item)}/>:
               item.icon==="discover"?<DiscoverIcon size={20} active={isActive(item)}/>:
               item.icon==="team"?<TeamIcon size={20} active={isActive(item)}/>:
               <span style={{fontSize:20}}>{item.icon}</span>}
              </span>
                  <span style={{fontSize:9,color:location.pathname===item.path?activeColor:theme.textMuted,textAlign:"center",lineHeight:1.3}}>{item.label||item.key}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
      <div style={{ position:"fixed", bottom:0, left:0, right:0, background:theme.bgSecondary, borderTop:`1px solid ${theme.border}`, display:"flex", zIndex:40, paddingBottom:"env(safe-area-inset-bottom)" }}>
        {bottomNav.map(item=>(
          <button key={item.path}
            onClick={item.path==="more"?()=>setMobileMenuOpen(true):()=>navigate(item.path)}
            style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:3, padding:"8px 4px", background:"transparent", border:"none", cursor:"pointer", color:isActive(item)?activeColor:theme.textFaint, borderTop:`2px solid ${isActive(item)?activeColor:"transparent"}` }}>
            <span style={{ position:"relative", display:"inline-block" }}>
              <span style={{ display:"flex", alignItems:"center", justifyContent:"center", animation:item.key==="notifications"&&unreadCount>0?"notif-glow 2s ease-in-out infinite":item.key==="messages"&&unreadChat>0?"chat-glow 2s ease-in-out infinite":undefined }}>
              {item.key==="overview" ? <HomeIcon size={22} active={isActive(item)} /> :
               item.key==="bookings" ? <BookingsIcon size={22} active={isActive(item)} /> :
               item.key==="findServices"||item.key==="myServices" ? <ServicesIcon size={22} active={isActive(item)} /> :
               item.key==="messages" ? <ChatIcon size={22} active={isActive(item)} /> :
               item.key==="notifications" ? <NotificationsIcon size={22} active={isActive(item)} hasAlert={unreadCount>0} /> :
               item.key==="payments" ? <PaymentsIcon size={22} active={isActive(item)} /> :
               item.key==="earnings"||item.key==="payouts" ? <WalletIcon size={22} active={isActive(item)} /> :
               item.key==="availableJobs" ? <OrdersIcon size={22} active={isActive(item)} /> :
               item.key==="activeDelivery" ? <VehicleIcon size={22} active={isActive(item)} /> :
               item.key==="analytics" ? <AnalyticsIcon size={22} active={isActive(item)} /> :
               item.key==="discover" ? <DiscoverIcon size={22} active={isActive(item)} /> :
               item.key==="loyalty" ? <LoyaltyIcon size={22} active={isActive(item)} /> :
               item.key==="favorites" ? <FavoritesIcon size={22} active={isActive(item)} /> :
               item.label==="Menu"||item.path==="more" ? <MenuIcon size={22} color={isActive(item)?"#e6821e":"#64748B"} /> :
               item.label==="Inventory" ? <OrdersIcon size={22} active={isActive(item)} /> :
               item.label==="Trip Reports" ? <TripReportIcon size={22} active={isActive(item)} /> :
               item.label==="Deliveries"||item.label==="Order Deliveries" ? <TruckDriverIcon size={22} active={isActive(item)} /> :
               item.icon==="users" ? <ProfileIcon size={22} active={isActive(item)} /> :
               item.icon==="wallet" ? <WalletIcon size={22} active={isActive(item)} /> :
               item.icon==="bookings" ? <BookingsIcon size={22} active={isActive(item)} /> :
               item.icon==="overview" ? <HomeIcon size={22} active={isActive(item)} /> :
               <span style={{fontSize:20}}>{item.icon}</span>}
            </span>
              {item.key==="notifications"&&unreadCount>0&&(
                <span style={{ position:"absolute", top:-4, right:-4, background:"#e24b4a", color:"#fff", borderRadius:"50%", fontSize:8, fontWeight:800, minWidth:14, height:14, display:"flex", alignItems:"center", justifyContent:"center" }}>{unreadCount>9?"9+":unreadCount}</span>
              )}
              {item.key==="messages"&&unreadChat>0&&(
                <span style={{ position:"absolute", top:-4, right:-4, background:"#378add", color:"#fff", borderRadius:"50%", fontSize:8, fontWeight:800, minWidth:14, height:14, display:"flex", alignItems:"center", justifyContent:"center", animation:"chat-glow 2s ease-in-out infinite" }}>{unreadChat>9?"9+":unreadChat}</span>
              )}
            </span>
            <span style={{ fontSize:9, fontFamily:"'DM Sans',sans-serif", fontWeight:isActive(item)?600:400 }}>{getLabel(item)}</span>
          </button>
        ))}
      </div>
    </div>
  )

  return (
    <div style={{ display:"flex", flexDirection:"row", height:"100vh", background:theme.bg||"#ffffff", fontFamily:"DM Sans,sans-serif", color:theme.text||"#000000", overflow:"hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');
        .nav-btn { display:flex; align-items:center; gap:9px; padding:8px 1rem; cursor:pointer; font-size:13px; color:${theme.textFaint}; border:none; background:none; width:100%; text-align:left; border-right:2px solid transparent; transition:all 0.12s; white-space:nowrap; overflow:hidden; }
        .nav-btn:hover { background:${theme.bgCardHover}; color:${theme.textMuted}; }
        .nav-btn.active { color:${activeColor}; border-right-color:${activeColor}; background:${activeBg}; }
        ::-webkit-scrollbar { width:4px; } ::-webkit-scrollbar-track { background:transparent; } ::-webkit-scrollbar-thumb { background:${theme.border}; border-radius:2px; }
      `}</style>

      <div style={{ width:collapsed?52:210, background:theme.bgSecondary, borderRight:`1px solid ${theme.border}`, display:"flex", flexDirection:"column", transition:"width 0.2s", flexShrink:0, overflow:"hidden", height:"100vh", position:"sticky", top:0 }}>
        <div style={{ padding:"1rem", display:"flex", alignItems:"center", gap:8, borderBottom:`1px solid ${theme.border}`, minHeight:52 }}>
          <div style={{ width:28, height:28, background:"#e6821e", borderRadius:6, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, flexShrink:0 }}>🚗</div>
          {!collapsed&&<span style={{ fontFamily:"Syne", fontSize:13, fontWeight:800, color:theme.text, whiteSpace:"nowrap" }}>Car<span style={{color:"#e6821e"}}>Care</span></span>}
        </div>

        <nav style={{ flex:1, paddingTop:6, overflowY:"auto", overflowX:"hidden" }}>
          {nav.map(item=>(
            <button key={item.path}
              className={`nav-btn${isActive(item)?" active":""}`}
              onClick={()=>navigate(item.path)}
              title={collapsed?getLabel(item):""}>
              <span style={{ display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              {item.key==="overview" ? <HomeIcon size={18} active={isActive(item)} /> :
               item.key==="bookings" ? <BookingsIcon size={18} active={isActive(item)} /> :
               item.key==="findServices"||item.key==="myServices" ? <ServicesIcon size={18} active={isActive(item)} /> :
               item.key==="messages" ? <ChatIcon size={18} active={isActive(item)} /> :
               item.key==="notifications" ? <NotificationsIcon size={18} active={isActive(item)} hasAlert={unreadCount>0} /> :
               item.key==="payments" ? <PaymentsIcon size={18} active={isActive(item)} /> :
               item.key==="earnings"||item.key==="payouts" ? <WalletIcon size={18} active={isActive(item)} /> :
               item.key==="reviews"||item.key==="myRatings" ? <StarIcon size={18} active={isActive(item)} /> :
               item.key==="analytics" ? <AnalyticsIcon size={18} active={isActive(item)} /> :
               item.key==="profile" ? <ProfileIcon size={18} active={isActive(item)} /> :
               item.key==="availability" ? <BookingsIcon size={18} active={isActive(item)} /> :
               item.key==="discover" ? <DiscoverIcon size={18} active={isActive(item)} /> :
               item.key==="loyalty" ? <LoyaltyIcon size={18} active={isActive(item)} /> :
               item.key==="favorites" ? <FavoritesIcon size={18} active={isActive(item)} /> :
               item.key==="referEarn" ? <ReferEarnIcon size={18} active={isActive(item)} /> :
               item.label==="GO Requests"||item.label==="GO Service 🚨" ? <GOServiceIcon size={18} /> :
               item.label==="Marketplace" ? <MarketplaceIcon size={18} active={isActive(item)} /> :
               item.label==="Mechanics"||item.label==="My Mechanics"||item.label==="Mechanics & Services"||item.key==="mechanics" ? <MechanicIcon size={18} active={isActive(item)} /> :
               item.label==="Drivers" ? <DriversIcon size={18} active={isActive(item)} /> :
               item.label==="Vehicles"||item.key==="myVehicles" ? <VehicleIcon size={18} active={isActive(item)} /> :
               item.label==="Settings" ? <SettingsIcon size={18} active={isActive(item)} /> :
               item.label==="Service Claims"||item.label==="My Claims" ? <ServiceGuaranteeIcon size={18} active={isActive(item)} /> :
               item.label==="Service Guarantee" ? <ServiceGuaranteeIcon size={18} active={isActive(item)} /> :
               item.label==="Orders" ? <OrdersIcon size={18} active={isActive(item)} /> :
               item.label==="Reports"||item.label==="Revenue" ? <ReportsIcon size={18} active={isActive(item)} /> :
               item.label==="Trip Reports" ? <TripReportIcon size={18} active={isActive(item)} /> :
               item.label==="Vehicle Reports" ? <VehicleReportIcon size={18} active={isActive(item)} /> :
               item.label==="2FA Security" ? <SecurityIcon size={18} active={isActive(item)} /> :
               item.label==="Payouts"||item.label==="Earnings" ? <WalletIcon size={18} active={isActive(item)} /> :
               item.label==="Support"||item.label==="Support Tickets" ? <HelpIcon size={18} active={isActive(item)} /> :
               item.label==="Spare Parts"||item.label==="Inventory" ? <PartsIcon size={18} active={isActive(item)} /> :
               item.label==="My Listings"||item.label==="My Car Listings" ? <MyListingsIcon size={18} active={isActive(item)} /> :
               item.label==="My Transactions" ? <MyTransactionsIcon size={18} active={isActive(item)} /> :
               item.label==="My Offers" ? <MarketplaceIcon size={18} active={isActive(item)} /> :
               item.label==="Refer & Earn"||item.key==="referEarn" ? <ReferEarnIcon size={18} active={isActive(item)} /> :
               item.label==="Loyalty" ? <LoyaltyIcon size={18} active={isActive(item)} /> :
               item.label==="Favourites"||item.label==="Favorites" ? <FavoritesIcon size={18} active={isActive(item)} /> :
               item.label==="Chat" ? <ChatIcon size={18} active={isActive(item)} /> :
               item.label==="Order Deliveries" ? <TruckDriverIcon size={18} active={isActive(item)} /> :
               item.icon==="overview" ? <HomeIcon size={18} active={isActive(item)} /> :
               item.icon==="users" ? <ProfileIcon size={18} active={isActive(item)} /> :
               item.icon==="map" ? <TripReportIcon size={18} active={isActive(item)} /> :
               item.icon==="block" ? <CloseIcon size={18} color="#e24b4a" /> :
               item.icon==="warning" ? <WarningIcon size={18} color="#e6821e" /> :
               item.icon==="payout" ? <PayoutIcon size={18} active={isActive(item)} /> :
               item.icon==="ticket" ? <TicketIcon size={18} active={isActive(item)} /> :
               item.icon==="helpTicket" ? <HelpIcon size={18} active={isActive(item)} /> :
               item.icon==="health" ? <HelpIcon size={18} active={isActive(item)} /> :
               item.icon==="commissions" ? <AnalyticsIcon size={18} active={isActive(item)} /> :
               item.icon==="adminSettings" ? <SettingsIcon size={18} active={isActive(item)} /> :
               item.icon==="qr" ? <QRCodeIcon size={18} active={isActive(item)} /> :
               item.icon==="video" ? <VideoIcon size={18} active={isActive(item)} /> :
               item.icon==="newCar" ? <VehicleIcon size={18} active={isActive(item)} /> :
               item.icon==="badge" ? <BadgeIcon size={18} active={isActive(item)} /> :
               item.icon==="team" ? <TeamIcon size={18} active={isActive(item)} /> :
               item.icon==="adminOrders" ? <OrdersIcon size={18} active={isActive(item)} /> :
               item.icon==="failedJobs" ? <WarningIcon size={18} color="#e24b4a" /> :
               item.icon==="delete" ? <DeleteIcon size={18} color="#e24b4a" /> :
               item.icon==="wallet" ? <WalletIcon size={18} active={isActive(item)} /> :
               item.icon==="notifications" ? <NotificationsIcon size={18} active={isActive(item)} /> :
               item.icon==="payments" ? <PaymentsIcon size={18} active={isActive(item)} /> :
               item.icon==="shield" ? <ShieldIcon size={18} active={isActive(item)} /> :
               item.icon==="security" ? <SecurityIcon size={18} active={isActive(item)} /> :
               item.icon==="analytics" ? <AnalyticsIcon size={18} active={isActive(item)} /> :
               item.icon==="parts" ? <PartsIcon size={18} active={isActive(item)} /> :
               item.icon==="settings" ? <SettingsIcon size={18} active={isActive(item)} /> :
               item.icon==="bookings" ? <BookingsIcon size={18} active={isActive(item)} /> :
               item.icon==="wallet" ? <WalletIcon size={18} active={isActive(item)} /> :
               item.icon==="star" ? <StarIcon size={18} active={isActive(item)} /> :
               item.icon==="payout" ? <PayoutIcon size={18} active={isActive(item)} /> :
               item.icon==="qr" ? <QRCodeIcon size={18} active={isActive(item)} /> :
               item.icon==="notifications" ? <NotificationsIcon size={18} active={isActive(item)} /> :
               item.icon==="messages" ? <ChatIcon size={18} active={isActive(item)} /> :
               item.icon==="clock" ? <ClockIcon size={18} active={isActive(item)} /> :
               item.icon==="overview" ? <HomeIcon size={18} active={isActive(item)} /> :
               item.icon==="services" ? <ServicesIcon size={18} active={isActive(item)} /> :
               item.icon==="orders" ? <OrdersIcon size={18} active={isActive(item)} /> :
               item.icon==="emergency" ? <GOServiceIcon size={18} color="#e24b4a" /> :
               item.icon==="reviews" ? <StarIcon size={18} active={isActive(item)} /> :
               item.icon==="helpTicket" ? <HelpIcon size={18} active={isActive(item)} /> :
               item.icon==="profile" ? <ProfileIcon size={18} active={isActive(item)} /> :
               item.icon==="discover" ? <DiscoverIcon size={18} active={isActive(item)} /> :
               <span style={{fontSize:16}}>{item.icon}</span>}
            </span>
              {!collapsed&&<span style={{ overflow:"hidden", textOverflow:"ellipsis" }}>{getLabel(item)}</span>}
            </button>
          ))}
        </nav>

        <div style={{ padding:"0.75rem", borderTop:`1px solid ${theme.border}` }}>
          {!collapsed&&(
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8, padding:"0.5rem", background:theme.bgCard, borderRadius:8 }}>
              <div style={{ width:28, height:28, borderRadius:"50%", background:activeBg, border:`1px solid ${activeColor}40`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:10, fontWeight:800, color:activeColor, flexShrink:0 }}>{initials}</div>
              <div style={{ minWidth:0, flex:1 }}>
                <div style={{ fontSize:12, color:theme.textMuted, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{profile?.first_name} {profile?.last_name}</div>
                <div style={{ fontSize:10, color:theme.textFaint, textTransform:"capitalize" }}>
                {role==="provider"?providerType.replace(/_/g," "):role}
              </div>
              </div>
            </div>
          )}
          {collapsed&&(
            <div style={{ width:28, height:28, borderRadius:"50%", background:activeBg, border:`1px solid ${activeColor}40`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:10, fontWeight:800, color:activeColor, margin:"0 auto 8px" }}>{initials}</div>
          )}

          <ThemeSwitcher collapsed={collapsed} />

          <button onClick={toggleLanguage}
            style={{ background:"none", border:`1px solid ${theme.border}`, borderRadius:6, color:theme.textFaint, cursor:"pointer", fontSize:11, width:"100%", textAlign:"center", fontFamily:"'DM Sans',sans-serif", padding:"5px 0", marginBottom:4 }}
            title={language==="en"?"Switch to Swahili":"Badilisha kwenda Kiingereza"}>
            {collapsed?"🌐":`🌐 ${language==="en"?"Kiswahili":"English"}`}
          </button>

          <button onClick={()=>setCollapsed(c=>!c)}
            style={{ background:"none", border:"none", color:theme.textVeryFaint, cursor:"pointer", fontSize:11, width:"100%", textAlign:"center", fontFamily:"'DM Sans',sans-serif", padding:"4px 0", marginBottom:6 }}>
            {collapsed?"→":`← ${t("collapse")}`}
          </button>

          <button onClick={signOut}
            style={{ background:"#fff5f5", border:"1px solid #e24b4a40", borderRadius:8, color:"#e24b4a", cursor:"pointer", fontSize:12, fontWeight:700, width:"100%", textAlign:"center", fontFamily:"'DM Sans',sans-serif", padding:"8px 0", transition:"all 0.12s" }}>
            {collapsed?"🚪":`🚪 ${t("signOut")}`}
          </button>
        </div>
      </div>

      <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0, overflow:"hidden", height:"100vh" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0.9rem 1.5rem", borderBottom:`1px solid ${theme.border}`, flexShrink:0, background:theme.bgSecondary }}>
          <div style={{ fontFamily:"Syne", fontSize:16, fontWeight:700, color:theme.text }}>
            {getLabel(nav.find(n=>isActive(n))||{}) || "Dashboard"}
          </div>
          <div style={{ fontSize:11, color:theme.textFaint }}>{new Date().toDateString()}</div>
        </div>
        <div style={{ flex:1, padding:"1.5rem", overflowY:"auto", background:theme.bg, minHeight:0 }}>{children}</div>
        <AIAssistant />
      <EmergencySOS />
      </div>
    </div>
  )
}























































































